import { ActionsColumn, TABLE_ACTION, TABLE_ACTION_STATE } from '@qrios/frontend-library';

import { VoiceBillingResponseItem, VOICEBillingTableData, VoiceBillingTableRowActions } from './interfaces';

export const mapApiDataIntoTableFormat = (
  data: VoiceBillingResponseItem[],
  actionsHandling: VoiceBillingTableRowActions
): VOICEBillingTableData[] =>
  data.map((voiceBillingItem: VoiceBillingResponseItem) => {
    const { cost, id, ...rest } = voiceBillingItem;

    const actions = [
      {
        name: TABLE_ACTION.INFO,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actionsHandling.openDetails(id);
        }
      }
    ];

    return {
      ...rest,
      id,
      cost: cost.value,
      actions: <ActionsColumn actions={actions} />
    };
  });
